export default __webpack_public_path__ + "static/media/pending-icon.f4f85306.svg";